import {MapperInterface} from "@share/web-conferences/interfaces/MapperInterface";
import {IAgoraRTCRemoteUser} from "agora-rtc-sdk-ng";
import {UserTracks} from "@share/web-conferences/types/UserTracks";
import {isShareScreen} from "@share/web-conferences/helpers/IsShareScreen";

export interface RemoteUserToUserTracksParams {
    isLocal: boolean;
}

export const toUserTracks: MapperInterface<IAgoraRTCRemoteUser, UserTracks> =
    (source: IAgoraRTCRemoteUser, params: RemoteUserToUserTracksParams = { isLocal: false }) => {
        return  {
            uid: source.uid,
            audio: source.audioTrack,
            video: source.videoTrack,
            isLocal: params?.isLocal ?? false,
            isScreenShare: isShareScreen(source.uid.toString())
        } as UserTracks;
    }
